export const siteSettings = {
  name: "EtGrowth",
  link: "https://etgrowth.net",
  email: "support@etgrowth.net",
  appLink: "https://app.etgrowth.net",
};
